/**
 * notification-popup.js
 * Lolahome — Pop-up de inscrição no cabeçalho (tema Horizon)
 *
 * Abre o <dialog-component> do popup depois do atraso configurado (data-delay,
 * em segundos), a menos que o cliente já tenha fechado o popup antes nesse
 * navegador (lembrado em localStorage) ou já seja inscrito na newsletter
 * (data-has-subscription="true", calculado no Liquid via customer.tags).
 */

const STORAGE_KEY = 'lh_notification_popup_dismissed';

function getRoot() {
  return document.querySelector('dialog-component[data-notification-popup="true"]');
}

function wasDismissed() {
  try {
    return localStorage.getItem(STORAGE_KEY) === '1';
  } catch (e) {
    return false;
  }
}

function markDismissed() {
  try {
    localStorage.setItem(STORAGE_KEY, '1');
  } catch (e) {
    // localStorage indisponível (modo privado, etc.) — sem persistência, sem problema
  }
}

async function initNotificationPopup() {
  const root = getRoot();
  if (!root) return;

  if (root.dataset.hasSubscription === 'true') return;
  if (wasDismissed()) return;

  await customElements.whenDefined('dialog-component');

  const delaySeconds = Number(root.dataset.delay) || 0;

  setTimeout(() => {
    if (typeof root.showDialog === 'function') {
      root.showDialog();
    }
  }, delaySeconds * 1000);

  root.addEventListener('dialog:close', markDismissed);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initNotificationPopup);
} else {
  initNotificationPopup();
}
